export default __webpack_public_path__ + "static/media/ecmascript6.9ce5fbcb.png";